var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsbIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 14,
    viewBox: "0 0 26 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1329_15788)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 7H20M1.5 1.5C1.5 1.5 1 2 1 3C1 4 1 11 1 11C1 11 1 12 1.5 12.5C2 13 3 13 3 13H23C23 13 24 13 24.5 12.5C25 12 25 11 25 11V3C25 3 25 2 24.5 1.5C24 1 23 1 23 1C23 1 4 1 3 1C2 1 1.5 1.5 1.5 1.5ZM6 4.5C6 4.5 4.5 5 4.5 7C4.5 9 6 9.5 6 9.5H20C20 9.5 21.5 9 21.5 7C21.5 5 20 4.5 20 4.5H6Z",
    stroke: "#85C7DE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1329_15788"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsbIcon);
export default __webpack_public_path__ + "static/media/USBIcon.e6100a754b9487572256cc2fa7758aaa.svg";
export { ForwardRef as ReactComponent };